import "./stars.css";
export default function Stars(props) {
  return <div className="stars"></div>;
}
